import './App.css';
import {createTheme, ThemeProvider} from '@material-ui/core/styles';
import TMSearch from "./components/TMSearch";
import React from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

const theme = createTheme({
    palette: {
        primary: {
            main: '#AB5212',
        },
        secondary: {
            main: '#AB5212',
        },
    },

    overrides: {
        // Style sheet name ⚛️
        MuiButton: {
            root: {
                borderRadius: 0,
            },
            contained: {
                boxShadow: "none"
            }
        },
        MuiOutlinedInput: {
            root: {
                borderRadius: 0,
            },
        }
    },
});

function App() {
    return (
        <ThemeProvider theme={theme}>
            <Navbar/>
          
            <div className="p-2 py-6 max-w-4xl mx-auto flex flex-col min-h-screen">
                <TMSearch/>
            </div>
          
           <Footer/> 
        </ThemeProvider> 
    );
}

export default App;
